const videoSource15 = [
  {
    id: "video16",
    src: require("./1_8.mp4"),
  },
];

export default videoSource15;
